
















































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Key, User, CertificateCreatePayload, KeyCsr, CsrState } from "bancojs";
import { debounce } from "@/services/core/Utils";

@Component
export default class AdminCertificatesCreate extends Vue {
  async created() {
    if (this.$route.query.key_id && this.$route.query.csr_id) {
      try {
        const key = await $api.client.admin.keys
          .get(Number(this.$route.query.key_id))
          .toPromise();
        this.form.keyList = [key];
        this.form.selectedKey = key;
        this.getCsrs(key.id);
        this.form.data.csr_id = Number(this.$route.query.csr_id);
      } catch (err) {
        console.log(err);
      }
    }
    this.form.loading = false;
  }

  async saveCertificate() {
    try {
      this.form.saving = true;
      await $api.client.admin.certificates.create(this.form.data).toPromise();
      this.form.saving = false;
      this.$router.push("/admin/certificates");
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  async _getKeys(newVal: string, oldVal: string) {
    if (newVal == null || newVal.length < 2) return;
    this.form.loadingKeys = true;
    const keys = await $api.client.admin.keys
      .find({ alias: newVal })
      .toPromise();
    this.form.loadingKeys = false;
    this.form.keyList = keys.content;
  }

  getCsrStateString(state: CsrState) {
    return state == "PENDING" ? "Pendiente" : "Completado";
  }

  @Watch("form.searchKey")
  getKeys = debounce(this._getKeys, 300);

  @Watch("form.isHiddenKey")
  onHiddenKeyChange(val: boolean, oldVal: boolean) {
    if (val) {
      this.form.data.csr_id = NaN;
      this.form.selectedKey = null;
    }
  }

  async getCsrs(key_id: number) {
    this.form.loadingCsrs = true;
    const csrs = await $api.client.admin.keys.listCsrForKey(key_id).toPromise();
    this.form.loadingCsrs = false;
    this.form.csrList = csrs;
  }

  pemFileToText(file: File) {
    if (!file) {
      this.form.data.pem = "";
      return;
    }
    const fr = new FileReader();
    fr.onload = (event) => {
      this.form.data.pem = event.target ? String(event.target.result) : "";
    };
    fr.readAsText(file);
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
  };

  form: {
    data: CertificateCreatePayload;
    keyList: Key[];
    searchKey: string;
    selectedKey: Key | null;
    isHiddenKey: boolean;
    csrList: KeyCsr[];
    searchCsr: string;
    loading: boolean;
    saving: boolean;
    loadingKeys: boolean;
    loadingCsrs: boolean;
    validForm: boolean;
    file: File | null;
  } = {
    data: {
      csr_id: NaN,
      pem: "",
      state: "ACTIVE",
    },
    keyList: [],
    searchKey: "",
    selectedKey: null,
    isHiddenKey: false,
    csrList: [],
    searchCsr: "",
    loading: true,
    saving: false,
    loadingKeys: false,
    loadingCsrs: false,
    validForm: false,
    file: null,
  };
}
